import React from "react";
import CheckboxList from "./CheckboxList";

interface BookkeepingCheckboxListProps {
  readonly?: boolean
  canBeEmpty?: boolean
  availableBookkeepings: server.dto.BookkeepingSmall[]
  selectedBookkeepingIds: number[]
  onChanged: (selectedBookkeepingIds: number[]) => void
  onSave?: () => void
}

export const BookkeepingCheckboxList = (props: BookkeepingCheckboxListProps) => {
  return <>
    <CheckboxList
      canBeEmpty={props.canBeEmpty}
      readonly={props.readonly}
      options={props.availableBookkeepings}
      getId={(bookkeeping) => bookkeeping.bookkeepingId}
      getTitle={(bookkeeping) => bookkeeping.name}
      selectedIds={props.selectedBookkeepingIds}
      onChange={props.onChanged}
      checkboxLabel={RESX.GeneralLabels.Visible}
      header={<>{RESX.Bookkeeping.resxBookkeeping}</>}
      validatorKey="bookkeepings"
    />
  </>
}